import { Component, OnInit } from '@angular/core';
import { BenutzerService } from "../service/benutzer.service";
import { UserInfo } from "../service/Model/UserInfo";
import { Router } from "@angular/router";
import { SelectItem } from "primeng/api";
import { MatSnackBar } from "@angular/material";
import { UserRole } from "../type/UserRole";
import { UserinfoService } from '../service/userinfo.service';

@Component({
  selector: 'app-administration-kraft',
  templateUrl: './app.administration.kraft.html',
  styleUrls: ['./app.administration.kraft.scss'],
})
export class AppAdministrationKraft implements OnInit {

  rollen: SelectItem[];
  adminAuswahl: SelectItem[];

  showBenutzerliste: boolean = false;
  benutzerBearbeitungDisabled: boolean = true;
  displayDialog: boolean = false;
  speichernDisabled: boolean = true;
  isBenslOk: boolean = false;
  isVtnrOk: boolean = true;

  benutzerliste: UserInfo[];
  user: UserInfo = {};
  selectedUser: UserInfo;
  newUser: boolean;
  labelBenutzerTabelleHeader: any[] = [
    {id: 1, label: 'Bensl'},
    {id: 2, label: 'Rolle'},
    {id: 3, label: 'VTNR-Berechtigungen'},
    {id: 4, label: 'Administrator'},
  ];

  constructor(private benutzerService: BenutzerService,
              private router: Router,
              private userinfoservice:UserinfoService,
              private snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.rollen = Object.values(UserRole).map(val => <SelectItem> ({label: val, value: val}));
    //mögliche Werte für Administrator
    this.adminAuswahl = [
      {label: 'y', value: 'y'},
      {label: 'n', value: 'n'},
    ];
    this.displayDialog = false;
    this.newUser = false;
    this.benutzerBearbeitungDisabled = true;

    this.speichernDisabled = true;
    this.isBenslOk= false;
    this.isVtnrOk = false;

    //laden aller User aus der Tabelle BENUTZER
    this.loadAllUsers();
  }

  onRowSelect(event) {
    this.newUser = false;
    this.user = this.cloneUser(event.data);
    this.benutzerBearbeitungDisabled = false;
  }

  onRowUnselect(event) {
    this.newUser = false;
    this.user = null;
    this.benutzerBearbeitungDisabled = true;
  }

  benutzerAnlegen(): void {
    this.newUser = true;
    this.user = {};
    this.user.rolle = UserRole.KEINE;
    this.user.rights = '*';
    this.user.isAdmin = 'n';
    this.selectedUser = this.cloneUser(this.user);
    this.displayDialog=true;
  }

  benutzerBearbeiten():void {
    console.log("benutzer bearbeiten: " + this.selectedUser.bensl);
    this.newUser = false;
    this.user = this.cloneUser(this.selectedUser);
    this.displayDialog=true;
    this.speichernDisabled = false;
    this.isBenslOk = true;
  }

  benutzerSpeichern(): void {
    let user = this.cloneUser(this.user);
    if (typeof user.rights === "string") {
      user.rights = (<string>this.user.rights).split(',');
    }
    if (user.rolle && user.isAdmin && user.bensl) {
      // call to Backend
      this.benutzerService.updateUser(user).subscribe((updatedUser) => {
        this.user = updatedUser;
        this.userinfoservice.setUserinfo(this.user);
        // update GUI
        let benliste = [...this.benutzerliste];
        if (this.newUser) {
          benliste.push(this.user);
        }
        else {
          benliste[this.benutzerliste.indexOf(this.selectedUser)] = this.user;
        }
        this.benutzerliste = benliste;
        this.user = null;
        this.benutzerBearbeitungDisabled = false;
        this.newUser = false;
        this.displayDialog = false;
      }, (error) => {
        this.snackBar.open("Fehler beim Speichern des Benutzers!", null, {duration: 3000, panelClass: ["bgc-red-400"]});
        this.errorHandling(error);
      });
   }
  }

  abbrechen():void {
    this.displayDialog=false;
    this.newUser = false;
    this.user = {};
  }

  benutzerLoeschen(): void {
    // call to backend
    let userId = this.selectedUser.benutzerId;
    this.benutzerService.deleteUser(userId).subscribe( (result) => {
      // löschen im GUI
      let index = this.benutzerliste.indexOf(this.selectedUser);
      this.benutzerliste = this.benutzerliste.filter((val, i) => i != index);
      this.user = null;
      this.benutzerBearbeitungDisabled = true;
    }, (error) => {
      this.snackBar.open("Fehler beim Löschen des Benutzers!", null, {duration: 3000, panelClass: ["bgc-red-400"]});
      this.errorHandling(error);
    });
  }

  zurueck(): void {
    console.log("zurück");
    this.router.navigate(['/index-kraft']);
  }

  cloneUser(user: UserInfo): UserInfo {
    let cloneUser = {};
    for (let prop in user) {
      cloneUser[prop] = user[prop];
    }
    return cloneUser;
  }

  private loadAllUsers() {
    this.benutzerService.getAllUsers().subscribe((userAusDB) => {
      this.benutzerliste = userAusDB;
      console.log("alle User aus DB ausgelesen, Anzahl: " + this.benutzerliste.length);
      if (this.benutzerliste.length > 0) {
        this.showBenutzerliste = true;
      }
    }, (error) => {
      this.snackBar.open("Fehler beim Laden der Benutzerliste!", null, {duration: 3000, panelClass: ["bgc-red-400"]});
      this.benutzerliste = null;
      this.showBenutzerliste = false;
      this.errorHandling(error);

    });
  }

  private errorHandling(error) {
    console.log(error);
    this.displayDialog = false;
    this.newUser = false;
    this.benutzerBearbeitungDisabled = true;
    this.speichernDisabled = true;
    this.isBenslOk= false;
    this.isVtnrOk = false;

  }

  changeDone(elementid: string) {
    if (!document.getElementById(elementid).classList.contains("ng-invalid")) {
      if (elementid == 'bensl') this.isBenslOk = true;
      if (elementid == 'rights') this.isVtnrOk = true;
    }
    else {
      if (elementid == 'bensl') this.isBenslOk = false;
      if (elementid == 'rights') this.isVtnrOk = false;
    }
    if (this.isVtnrOk && this.isBenslOk ) {
      this.speichernDisabled = false;
    }
    else {
      this.speichernDisabled = true;
    }
  }
}


